module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Calculadora de patrimonio"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Activos',
      "videoEmbed": "ADMINISTRACIONDINERO51Activos.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('p', [_vm._v("\r\n        Lo primero es saber a cuanto ascienden sus activos. Diligencie el siguiente formato y revíselo periódicamente.\r\n\r\n      ")]), _vm._v(" "), _c('p', [_vm._v("\r\n        Importante: Digite las cifras sin puntos ni comas.\r\n      ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('ui-calculadora-patri', {
    attrs: {
      "formulario": _vm.patrimonioActivo,
      "nombresCols": "Activos"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c46eb37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-51.vue
// module id = 1023
// module chunks = 1